import React from 'react';
import Icon from '../../../components/AppIcon';

const StatisticsOverview = ({ upcomingCount, activeCount, completedCount, totalMeetings }) => {
  const stats = [
    {
      label: 'Upcoming',
      value: upcomingCount,
      icon: 'Clock',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      borderColor: 'border-warning/20'
    },
    {
      label: 'Active',
      value: activeCount,
      icon: 'Navigation',
      color: 'text-success',
      bgColor: 'bg-success/10',
      borderColor: 'border-success/20'
    },
    {
      label: 'Completed',
      value: completedCount,
      icon: 'CheckCircle',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      borderColor: 'border-primary/20'
    },
    {
      label: 'Total Meetings',
      value: totalMeetings,
      icon: 'Calendar',
      color: 'text-accent',
      bgColor: 'bg-accent/10',
      borderColor: 'border-accent/20'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
      {stats?.map((stat, index) => (
        <div
          key={index}
          className={`bg-card rounded-lg border ${stat?.borderColor} p-6 transition-smooth hover-lift`}
        >
          <div className="flex items-center justify-between mb-4">
            <div className={`w-12 h-12 rounded-lg ${stat?.bgColor} flex items-center justify-center`}>
              <Icon name={stat?.icon} size={24} className={stat?.color} />
            </div>
            <div className="text-right">
              <div className="text-3xl font-bold text-foreground">{stat?.value}</div>
            </div>
          </div>
          <div className="text-sm font-medium text-muted-foreground">{stat?.label}</div>
        </div>
      ))}
    </div>
  );
};

export default StatisticsOverview;